var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdministration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: ""
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.4328 42.2475H67.7526V21.5876H72.9277V37.0927H88.4328V42.2475Z",
    fill: "#2FB29C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1752 24.1752H69.2806L85.8452 40.7397V96.5051H34.1752V24.1752ZM29 19V101.68H91V38.6004L71.42 19H29Z",
    fill: "#2FB29C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5153 57.7526H44.5051V62.9277H75.5153V57.7526Z",
    fill: "#2FB29C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5153 68.0825H44.5051V73.2577H75.5153V68.0825Z",
    fill: "#2FB29C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5153 78.4327H44.5051V83.6079H75.5153V78.4327Z",
    fill: "#2FB29C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5153 47.4226H44.5051V52.5978H75.5153V47.4226Z",
    fill: "#2FB29C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5978 37.0927H44.5051V42.2678H62.5978V37.0927Z",
    fill: "#2FB29C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdministration);
export default __webpack_public_path__ + "static/media/administration.1a3a1fc888d27216e9362499acec64c2.svg";
export { ForwardRef as ReactComponent };